<script setup lang="ts">

import { AppText } from '@shared/ui/typography'
import { ModalDefault } from '@shared/ui/modals'
import { BtnSecondary } from '@shared/ui/buttons'

import { useModalChangelogDetail } from '../model/modal-changelog-detail.hook'

defineOptions({
  name: 'ModalChangelogDetail',
})

const {
  refIsOpen,
  refTitle,
  refRows,
  closeModal,
} = useModalChangelogDetail()
</script>

<template>
  <ModalDefault
    :show="refIsOpen"
    :title="refTitle"
    @click:overlay="closeModal"
  >
    <div class="modal-changelog-detail">
      <div
        v-for="row in refRows"
        :key="row.label"
        class="modal-changelog-detail__row"
      >
        <AppText
          name="body2"
          color="slate-500"
          class="modal-changelog-detail__label"
        >
          {{ row.label }}
        </AppText>
        <AppText
          name="body2"
          class="modal-changelog-detail__value"
        >
          {{ row.value }}
        </AppText>
      </div>
    </div>

    <template #controls>
      <BtnSecondary
        text="Close"
        @click="closeModal"
      />
    </template>
  </ModalDefault>
</template>

<style scoped lang="scss" src="./ModalChangelogDetail.scss" />
